import { type FunctionComponent, Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { AttachLinksPopoverProps } from './AttachLinksPopover';

export const LazyAttachLinksPopover: FunctionComponent<
  AttachLinksPopoverProps
> = (props) => {
  const AttachLinksPopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "attach-links-popover" */ './AttachLinksPopover'
      ),
    { namedImport: 'AttachLinksPopover' },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <AttachLinksPopover {...props} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
